import {
  Monitor, Shield, Globe, Smartphone, Cloud, Brain, Layers, Handshake, DatabaseBackup,
  Settings, Server, BarChart3, Headphones, Wrench, LifeBuoy, MonitorCheck, HardDrive,
  Lock, ScanEye, KeyRound, ShieldCheck, Code2, Layout, Palette, Search,
  TabletSmartphone, Fingerprint, Download, Bell, CloudUpload, Database, Wifi, RefreshCw,
  Cpu, Sparkles, CircuitBoard, Zap, Users, FileCheck, ArrowLeftRight, ClipboardList,
  HardDriveDownload, RotateCcw, ServerCrash, ShieldAlert,
  CheckCircle, CircleCheck, Activity, Airplay, AlertTriangle, Archive, Award,
  Bookmark, Box, Briefcase, Calendar, Camera, Check, ChevronRight, Clock,
  Cog, CreditCard, Eye, File, Filter, Flag, Folder, Gift, Heart, Home,
  Image, Info, Key, Lightbulb, Link, List, Mail, Map, MapPin, MessageCircle,
  Mic, Package, Phone, PieChart, Play, Plug, Plus, Power, Printer, Radio,
  Rocket, Save, Send, Share2, ShoppingCart, Star, Target, Terminal, ThumbsUp,
  Trash2, TrendingUp, Truck, Upload, Video, Volume2, Wand2, type LucideIcon,
} from "lucide-react";

export const iconMap: Record<string, LucideIcon> = {
  "monitor": Monitor, "shield": Shield, "globe": Globe, "smartphone": Smartphone,
  "cloud": Cloud, "brain": Brain, "layers": Layers, "handshake": Handshake,
  "database-backup": DatabaseBackup, "settings": Settings, "server": Server,
  "bar-chart-3": BarChart3, "headphones": Headphones, "wrench": Wrench,
  "life-buoy": LifeBuoy, "monitor-check": MonitorCheck, "hard-drive": HardDrive,
  "lock": Lock, "scan-eye": ScanEye, "key-round": KeyRound, "shield-check": ShieldCheck,
  "code-2": Code2, "layout": Layout, "palette": Palette, "search": Search,
  "tablet-smartphone": TabletSmartphone, "fingerprint": Fingerprint, "download": Download,
  "bell": Bell, "cloud-upload": CloudUpload, "database": Database, "wifi": Wifi,
  "refresh-cw": RefreshCw, "cpu": Cpu, "sparkles": Sparkles, "circuit-board": CircuitBoard,
  "zap": Zap, "users": Users, "file-check": FileCheck, "arrow-left-right": ArrowLeftRight,
  "clipboard-list": ClipboardList, "hard-drive-download": HardDriveDownload,
  "rotate-ccw": RotateCcw, "server-crash": ServerCrash, "shield-alert": ShieldAlert,
  "check-circle": CheckCircle, "circle-check": CircleCheck, "activity": Activity,
  "airplay": Airplay, "alert-triangle": AlertTriangle, "archive": Archive, "award": Award,
  "bookmark": Bookmark, "box": Box, "briefcase": Briefcase, "calendar": Calendar,
  "camera": Camera, "check": Check, "chevron-right": ChevronRight, "clock": Clock,
  "cog": Cog, "credit-card": CreditCard, "eye": Eye, "file": File, "filter": Filter,
  "flag": Flag, "folder": Folder, "gift": Gift, "heart": Heart, "home": Home,
  "image": Image, "info": Info, "key": Key, "lightbulb": Lightbulb, "link": Link,
  "list": List, "mail": Mail, "map": Map, "map-pin": MapPin,
  "message-circle": MessageCircle, "mic": Mic, "package": Package, "phone": Phone,
  "pie-chart": PieChart, "play": Play, "plug": Plug, "plus": Plus, "power": Power,
  "printer": Printer, "radio": Radio, "rocket": Rocket, "save": Save, "send": Send,
  "share-2": Share2, "shopping-cart": ShoppingCart, "star": Star, "target": Target,
  "terminal": Terminal, "thumbs-up": ThumbsUp, "trash-2": Trash2,
  "trending-up": TrendingUp, "truck": Truck, "upload": Upload, "video": Video,
  "volume-2": Volume2, "wand-2": Wand2,
};

export const resolveIcon = (name: string): LucideIcon => {
  return iconMap[name] || CircleCheck;
};

export const curatedIconNames = Object.keys(iconMap);
